import React from 'react'
import Loader from '../../UIComponents/Spinner/Spinner';

export default function Spinner({isLoading, children}) {
    if (isLoading) return <Loader />;
    return <>{children}</>;
}
